"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monteroni-d-arbia": {
    "cc9dbe46": [{
      "hkey": "fb84dd17",
      "slug": "cuna-more",
      "name": "Cuna-More",
      "primary": true,
      "skipSearch": false
    }],
    "cuna-le-more": [{
      "hkey": "fb84dd17",
      "slug": "cuna-more",
      "name": "Cuna-More",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;